import React from 'react';
import { Link } from 'react-router-dom';
import {
  IconCell,
  Td,
  HashLink,
  AppIcon,
  MalwareFamilyBadge,
  StatusBadge,
  ButtonContainer,
  IntelButton,
  ErrorTooltip
} from '../../../styles/HomeStyles';

const formatDate = (dateString) => {
  try {
    return new Date(dateString).toLocaleString();
  } catch (e) {
    return 'N/A';
  }
};

const TableRow = ({ analysis }) => {
  // Fallback for placeholder image
  const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

  return (
    <tr>
      <IconCell>
        {analysis.icon ? (
          <AppIcon
            src={`data:image/png;base64,${analysis.icon}`}
            alt="App Icon"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = placeholderImage;
            }}
          />
        ) : (
          <AppIcon
            src={placeholderImage}
            alt="No Icon"
          />
        )}
      </IconCell>
      <Td>
        <HashLink
          as={Link}
          to={`/analysis/${analysis.sha256}`}
        >
          {analysis.sha256.substring(0, 8)}...
        </HashLink>
      </Td>
      <Td>{analysis.package_name}</Td>
      <Td>{analysis.app_name}</Td>
      <Td>
        <MalwareFamilyBadge
          type={(!analysis.malware_family || analysis.malware_family === 'Unknown') ? 'unknown' : 'malware'}
        >
          {analysis.malware_family || 'Unknown'}
        </MalwareFamilyBadge>
      </Td>
      <Td>
        <StatusBadge status={analysis.analysis_status || 'pending'}>
          {analysis.analysis_status || 'pending'}
          {analysis.analysis_status === 'failed' && analysis.analysis_error && (
            <ErrorTooltip>ⓘ<span>{analysis.analysis_error}</span></ErrorTooltip>
          )}
        </StatusBadge>
      </Td>
      <Td>{formatDate(analysis.timestamp?.$date || analysis.timestamp)}</Td>
      <Td>
        <ButtonContainer>
          <IntelButton
            type="playstore"
            title="Play Store"
            disabled={!analysis.intelligence?.playstore?.is_available || analysis.intelligence.playstore.is_available === "False"}
            onClick={() => window.open(`https://play.google.com/store/apps/details?id=${analysis.package_name}`, '_blank')}
          >
            P
          </IntelButton>
          <IntelButton
            type="virustotal"
            title="VirusTotal"
            disabled={!analysis.intelligence?.virustotal?.is_available || analysis.intelligence.virustotal.is_available === "False"}
            onClick={() => window.open(`https://www.virustotal.com/gui/file/${analysis.sha256}`, '_blank')}
          >
            V
          </IntelButton>
        </ButtonContainer>
      </Td>
    </tr>
  );
};

export default TableRow;